export const NAMESPACE = 'analytics';

export const START_TYPING_TEST_NAME = `${NAMESPACE}/START_TYPING_TEST_NAME`;
export const ALL_TESTS_LOADED = `${NAMESPACE}/TEST_LOADING_COMPLETE`;
